(function () {
  if (window.__rabitatDiwaliLp) return;
  window.__rabitatDiwaliLp = true;

  function headerOffset() {
    var header = document.querySelector('sticky-header, .header, #header, [data-header]');
    return header ? header.getBoundingClientRect().height + 8 : 80;
  }

  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-diwali-jump]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var id = href.slice(1);
    if (!id) return;
    event.preventDefault();
    scrollToId(id);
    if (history.replaceState && window.location.hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  });

  if (window.location.hash) {
    var hashId = window.location.hash.replace('#', '');
    if (hashId) {
      window.setTimeout(function () {
        scrollToId(hashId);
      }, 200);
    }
  }

  function bindQuickAdd(root) {
    root.querySelectorAll('[data-diwali-quick-add]').forEach(function (button) {
      if (button.dataset.diwaliQuickBound === 'true') return;
      button.dataset.diwaliQuickBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var card = button.closest('[data-diwali-card]');
        var jsonEl = card ? card.querySelector('[data-product-quick-add]') : null;
        if (!jsonEl) return;
        try {
          var data = JSON.parse(jsonEl.textContent);
          var variantId =
            button.getAttribute('data-current-variant-id') ||
            (card && card.getAttribute('data-initial-variant-id'));
          document.dispatchEvent(
            new CustomEvent('rabitat:quick-add:open', {
              detail: { data: data, variantId: variantId },
            })
          );
        } catch (error) {
          console.error('Diwali LP quick add parse error:', error);
        }
      });
    });
  }

  function activeTrack(section) {
    var panel = section.querySelector('[data-diwali-price-panel]:not([hidden])');
    if (panel) return panel.querySelector('[data-diwali-track]');
    return section.querySelector('[data-diwali-track]');
  }

  function stepSize(track) {
    var card = track.querySelector('.diwali-lp-card');
    if (!card) return 274;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 12;
    return card.getBoundingClientRect().width + gap;
  }

  function syncNavVisibility(section) {
    var nav = section.querySelector('.diwali-lp-nav');
    if (!nav) return;
    var track = activeTrack(section);
    var count = track ? track.querySelectorAll('.diwali-lp-card').length : 0;
    nav.classList.toggle('diwali-lp-nav--few', count > 0 && count < 5);
  }

  function updateFill(section) {
    var fill = section.querySelector('[data-diwali-fill]');
    if (!fill) return;
    var track = activeTrack(section);
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var ratio = max <= 0 ? 0 : Math.min(1, Math.max(0, track.scrollLeft / max));
    fill.style.width = 37 + ratio * 63 + '%';
    syncNavVisibility(section);
  }

  function bindCarousel(section) {
    var prev = section.querySelector('[data-dir="prev"]');
    var next = section.querySelector('[data-dir="next"]');
    var pager = section.querySelector('[data-diwali-progress]');
    var tracks = section.querySelectorAll('[data-diwali-track]');

    function scrollTrack(dir) {
      var track = activeTrack(section);
      if (!track) return;
      track.scrollBy({ left: dir * stepSize(track), behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollTrack(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollTrack(1);
      });
    }

    tracks.forEach(function (track) {
      track.addEventListener('scroll', function () {
        if (track !== activeTrack(section)) return;
        updateFill(section);
      }, { passive: true });
    });

    if (pager) {
      pager.addEventListener('click', function (event) {
        var track = activeTrack(section);
        if (!track) return;
        var bar = pager.querySelector('.diwali-lp-nav__bar') || pager;
        var rect = bar.getBoundingClientRect();
        var ratio = rect.width ? (event.clientX - rect.left) / rect.width : 0;
        ratio = Math.min(1, Math.max(0, ratio));
        var max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: max * ratio, behavior: 'smooth' });
      });
    }

    updateFill(section);
  }

  function bindPriceTabs(section) {
    var tabs = section.querySelectorAll('[data-diwali-price-tab]');
    var panels = section.querySelectorAll('[data-diwali-price-panel]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-tab-index');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        panels.forEach(function (panel) {
          var match = panel.getAttribute('data-tab-index') === index;
          panel.hidden = !match;
        });
        updateFill(section);
      });
    });
  }

  function bindChat(section) {
    if (!section.hasAttribute('data-diwali-chat')) return;
    if (section.dataset.diwaliChatBound === 'true') return;
    section.dataset.diwaliChatBound = 'true';

    var leftTyping = section.querySelector('[data-chat-typing="left"]');
    var rightTyping = section.querySelector('[data-chat-typing="right"]');
    var leftBubble = section.querySelector('[data-chat-bubble="left"]');
    var rightBubble = section.querySelector('[data-chat-bubble="right"]');
    if (!leftBubble || !rightBubble) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timers = [];
    var playing = false;

    function show(el) {
      if (el) el.classList.add('is-in');
    }

    function typing(el, on) {
      if (!el) return;
      el.classList.toggle('is-on', on);
    }

    function clearTimers() {
      timers.forEach(function (id) {
        window.clearTimeout(id);
      });
      timers = [];
    }

    function later(fn, ms) {
      timers.push(window.setTimeout(fn, ms));
    }

    function reset() {
      clearTimers();
      playing = false;
      typing(leftTyping, false);
      typing(rightTyping, false);
      if (leftBubble) leftBubble.classList.remove('is-in');
      if (rightBubble) rightBubble.classList.remove('is-in');
    }

    function play() {
      if (playing) return;
      playing = true;
      if (reduced) {
        show(leftBubble);
        show(rightBubble);
        return;
      }
      typing(leftTyping, true);
      later(function () {
        typing(leftTyping, false);
        show(leftBubble);
      }, 900);
      later(function () {
        typing(rightTyping, true);
      }, 1500);
      later(function () {
        typing(rightTyping, false);
        show(rightBubble);
      }, 2600);
    }

    if (!('IntersectionObserver' in window)) {
      play();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.4) {
            play();
          } else if (entry.intersectionRatio < 0.12) {
            reset();
          }
        });
      },
      { threshold: [0, 0.12, 0.4] }
    );
    observer.observe(section);
  }

  function bindStickyJump() {
    var jump = document.querySelector('.diwali-lp-jump');
    var sticky = document.querySelector('[data-diwali-sticky]');
    if (!jump || !sticky) return;

    var row = sticky.querySelector('.diwali-lp-sticky__row');
    var links = Array.prototype.slice.call(sticky.querySelectorAll('[data-diwali-sticky-link]'));
    var targets = links
      .map(function (link) {
        var href = link.getAttribute('href') || '';
        var id = href.charAt(0) === '#' ? href.slice(1) : '';
        var el = id ? document.getElementById(id) : null;
        return el ? { id: id, el: el, link: link } : null;
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.el.offsetTop - b.el.offsetTop;
      });
    var currentId = '';

    function revealLink(link) {
      if (!row || !link) return;
      var rowRect = row.getBoundingClientRect();
      var linkRect = link.getBoundingClientRect();
      var delta = linkRect.left + linkRect.width / 2 - (rowRect.left + rowRect.width / 2);
      var max = row.scrollWidth - row.clientWidth;
      row.scrollTo({
        left: Math.max(0, Math.min(max, row.scrollLeft + delta)),
        behavior: 'smooth',
      });
    }

    function setActive(id, forceReveal) {
      var activeLink = null;
      links.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        var on = href === '#' + id;
        link.classList.toggle('is-active', on);
        if (on) activeLink = link;
      });
      if (!activeLink) return;
      if (forceReveal || currentId !== id) revealLink(activeLink);
      currentId = id;
    }

    function update() {
      var headerTop = headerOffset() - 8;
      var pastJump = jump.getBoundingClientRect().bottom <= headerTop + 4;
      sticky.classList.toggle('is-visible', pastJump);
      document.body.style.paddingBottom = pastJump ? sticky.offsetHeight + 'px' : '';

      if (!pastJump || !targets.length) return;
      var line = headerOffset() + 12;
      var activeId = targets[0].id;
      targets.forEach(function (item) {
        if (item.el.getBoundingClientRect().top - line <= 0) {
          activeId = item.id;
        }
      });
      setActive(activeId);
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-diwali-jump]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var id = href.slice(1);
      if (id) setActive(id, true);
    });

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function bindEssentialsTabs(section) {
    var root = section.hasAttribute('data-diwali-essentials')
      ? section
      : section.querySelector('[data-diwali-essentials]');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-essentials-tab]');
    var panels = root.querySelectorAll('[data-essentials-panel]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-essentials-tab');
        tabs.forEach(function (item) {
          var on = item === tab;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-essentials-panel') !== id;
        });
      });
    });
  }

  document.querySelectorAll('[data-diwali-lp]').forEach(function (section) {
    bindQuickAdd(section);
    bindCarousel(section);
    bindPriceTabs(section);
    bindChat(section);
    bindEssentialsTabs(section);
  });
  bindStickyJump();

  document.addEventListener('rabitat:collection:updated', function (event) {
    var root = event.detail && event.detail.root;
    if (root) bindQuickAdd(root);
  });
})();
